import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingState } from '../components/common';
import { theme } from '../design/theme';

export const AppShell: React.FC = () => {
  return (
    <div style={{
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.body.fontSize,
      color: theme.colors.neutral[900],
      backgroundColor: theme.colors.background.muted,
      minHeight: '100vh'
    }}>
      <Suspense fallback={<LoadingState />}>
        <Outlet />
      </Suspense>
    </div>
  );
};
